import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import { File as UploadedFile } from '../../../../../graphql/generated/graphql';
import { OnUploadProgress } from '../../../../../service/persistent/FileUploader';
import { SPACING_UNIT } from '../../../../constant/spacing';
import _CreativeUploader from './CreativeUploader';

interface Props {
  uploadedFile: UploadedFile | null;
  uploadCreative: (file: File | null, onUploadProgress?: OnUploadProgress) => void;
  uploadingCreative: boolean;
  className?: string;
}

const CreativeSubmissionForm = ({
  uploadedFile,
  uploadCreative,
  uploadingCreative,
  className,
}: ClassAttributes<HTMLElement> & Props) => (
  <Root className={className}>
    <CreativeUploader
      uploadedFile={uploadedFile}
      uploadCreative={uploadCreative}
      uploadingCreative={uploadingCreative}
    />
  </Root>
);

const Root = styled('div')({});
const CreativeUploader = styled(_CreativeUploader)({ marginBottom: SPACING_UNIT });

export default CreativeSubmissionForm;
